// extracted by mini-css-extract-plugin
export var divider = "_o7-0";
export var systemMessage = "_o7-1";